import React from 'react'
import { track } from '../../shared/analytics';
import Button from '../Elements/Button';
import './Navbar.scss';

const Navbar = () => {
    return (
        <div className="navbar-component">
            <div className="container">
                <Logo />
                <GameGuide />
            </div>
        </div>
    )
}

const Logo = () => {
    return (
        <img src={require('../../images/logo-nft.svg').default} alt="logo" />
    )
}

const GameGuide = () => {
    return (
        <Button className="button" buttonText="GAME GUIDE" onClick={() => {
            track("about the game - game guide");
            window.open("https://cotinetwork.medium.com/coti-will-launch-an-nft-game-with-insane-coti-prizes-of-over-2-000-000-coti-57f6d6acd0ef", '_blank');
        }} />
    )
}

export default Navbar;